import { Divisor, PilaH, PilaV, Texto } from '@/components/atomos';
import { formatCurrency } from '@/helpers/currency';
import useComboEstados from '@/hooks/useComboEstados';
import { InfoBannerHome } from '@/models/respuestas/usuario.model';
import { CARGANDO, INACTIVO } from '@/redux/constantes';
import { Badge, Skeleton } from '@chakra-ui/react';
import { DollarSign, File, Hash, LucideIcon } from 'lucide-react';
import { FC, PropsWithChildren } from 'react';

const propsIconos = {
  size: '18',
  color: 'var(--foreground-secondary)',
};

type OperacionBanner = InfoBannerHome['operacion'];

interface Props extends OperacionBanner {
  cargando: boolean;
}

interface PropsSeccionOperacion extends PropsWithChildren {
  Icono: LucideIcon;
  cargando: boolean;
}

const SeccionOperacion: FC<PropsSeccionOperacion> = ({
  children,
  cargando,
  Icono,
}) => {
  return (
    <Skeleton isLoaded={!cargando} w={'100px'}>
      <PilaH spacing={1}>
        <Icono {...propsIconos} />
        <Texto>{children}</Texto>
      </PilaH>
    </Skeleton>
  );
};

const InfoUltimaOperacionBannerHome: FC<Props> = ({
  cantidadDocumentos,
  estadoOperacion,
  montoTotalOperacion,
  nroOperacion,
  cargando: cargandoInfo,
  idEstado,
  idOperacion,
}) => {
  const { estadosCombo, estado } = useComboEstados();
  const cargando = estado === CARGANDO || estado === INACTIVO || cargandoInfo;

  if (!cargando && !idOperacion) return null;

  return (
    <>
      <PilaV alignItems={'start'} spacing={1}>
        <Skeleton isLoaded={!cargando}>
          <PilaH spacing={1}>
            <Texto fontWeight={'semibold'} fontSize={'lg'}>
              Ultima operación
            </Texto>

            {!cargando ? (
              <Badge
                color={estadosCombo[idEstado]?.colorPrimario}
                bg={estadosCombo[idEstado]?.colorSecundario}
              >
                {estadoOperacion}
              </Badge>
            ) : null}
          </PilaH>
        </Skeleton>
        <SeccionOperacion Icono={Hash} cargando={cargando}>
          {nroOperacion}
        </SeccionOperacion>
        <SeccionOperacion Icono={File} cargando={cargando}>
          {cantidadDocumentos}
        </SeccionOperacion>
        <SeccionOperacion Icono={DollarSign} cargando={cargando}>
          {formatCurrency(Number(montoTotalOperacion)).replace('$', '')}
        </SeccionOperacion>
      </PilaV>
      <Divisor orientation='vertical' h='130px' />
    </>
  );
};

export default InfoUltimaOperacionBannerHome;
